import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const DEFAULT_BLUE_COLORS = [
  "#0f172a",
  "#1e293b",
  "#1e3a8a",
  "#1d4ed8",
  "#2563eb",
  "#3b82f6",
  "#60a5fa",
  "#93c5fd",
  "#bfdbfe",
  "#dbeafe",
];

type PieChartDataItem = {
  label: string;
  value: number;
};

type PieChartColor = {
  key: string;
  color: string;
};

type CustomPieChartProps = {
  data: PieChartDataItem[];
  colors?: PieChartColor[];
  height?: number;
  className?: string;
};

const normalizeKey = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/_/g, " ")
    .trim()
    .toLowerCase();

const CustomPieChart = ({
  data,
  colors,
  height = 270,
  className,
}: CustomPieChartProps) => {
  const colorMap = new Map(
    colors?.map((item) => [normalizeKey(item.key), item.color]),
  );

  return (
    <div className={className}>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="45%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={4}
            dataKey="value"
            nameKey="label"
            isAnimationActive
          >
            {data.map((item, index) => {
              const fallbackColor =
                DEFAULT_BLUE_COLORS[index % DEFAULT_BLUE_COLORS.length];

              return (
                <Cell
                  key={`cell-${item.label}`}
                  name={item.label}
                  fill={colorMap.get(normalizeKey(item.label)) ?? fallbackColor}
                />
              );
            })}
          </Pie>

          <Tooltip
            contentStyle={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "12px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
            }}
          />

          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomPieChart;
